module.exports = __webpack_public_path__ + "media/images/wedding/thumb/11-cb078b5c72c8bd339a00868ad17de759.jpg";